import axios from 'axios';
import authHeader from './auth-header';
import Jsona from "jsona";

const API_URL = process.env.VUE_APP_API_BASE_URL;
const dataFormatter = new Jsona();

export default {
    async getContacts(params) {
        const response = await axios.get(API_URL + "/contacts", {headers: authHeader(), params: params});
        return {data: dataFormatter.deserialize(response.data), meta: response.data.meta?.page};
    },

    async getStatus(params) {
        const response = await axios.get(API_URL + "/contacts/status", {headers: authHeader(), params: params});
        return {data: response.data.data, meta: response.data.meta?.page};
    },

    async getContactsBaseData(params) {
        const response = await axios.get(API_URL + "/data/contacts", {headers: authHeader(), params: params});
        return response.data;
    },

    async addContact(contact) {
        contact.type = "contacts";
        const formData = new FormData();
        Object.keys(contact).forEach(key => {
            if (key !== "files") {
                formData.append(`data[attributes][${key}]`, contact[key]);
            }
        });
        if (contact.files && contact.files.length > 0) {
            contact.files.forEach(file => {
                formData.append("file[]", file);
            });
        }
        const response = await axios.post(API_URL + "/contacts/add", formData, {
            headers: {
                ...authHeader(),
                "Content-Type": "multipart/form-data"
            }
        });
        return dataFormatter.deserialize(response.data);
    },

    async deleteContact(contactId) {
        await axios.delete(API_URL + "/contacts/" + contactId, {headers: authHeader()});
    },

    async getContact(contactId) {
        const response = await axios.get(API_URL + "/contacts/" + contactId, {headers: authHeader()});
        return dataFormatter.deserialize(response.data);
    },

    async editContact(contact) {
        contact.type = "contacts";
        const formData = new FormData();
        Object.keys(contact).forEach(key => {
            if (key !== "files") {
                formData.append(`data[attributes][${key}]`, contact[key]);
            }
        });
        if (contact.files && contact.files.length > 0) {
            contact.files.forEach(file => {
                formData.append("file[]", file);
            });
        }
        const response = await axios.post(API_URL + "/contacts/edit/" + contact.id, formData, {
            headers: {
                ...authHeader(),
                "Content-Type": "multipart/form-data"
            }
        });
        return dataFormatter.deserialize(response.data);
    },
}